import request from '@/utils/http.js';

// 获取领奖页的设置信息
const getReceiveAwardSetting = params => {
  return request('/v3/vss/interact-reward/get-receive-award-setting', {
    method: 'POST',
    data: params
  });
};


// 获取中奖人信息
const getWinnerInfo = params => {
  return request('/v3/vss/interact-reward/winner-info', {
    method: 'POST',
    data: params
  });
};


// 提交领奖信息（寄送奖品情况下才需要）
const saveAwardInfo = params => {
  return request('/v3/vss/interact-reward/save-award-info', {
    method: 'POST',
    data: params
  });
};


// 获取我的礼品列表
const getMyAwardList = params => {
  return request('/v3/vss/interact-reward/my-award-list', {
    method: 'POST',
    data: params
  });
};

export default {
  getReceiveAwardSetting,
  getWinnerInfo,
  saveAwardInfo,
  getMyAwardList
}